<script>
// import Gltf from '../snippets/Gltf'

import getOptionsString from '@/util/getOptionsString'

export default {

  // components: {
  //   Gltf
  // },

  data () {
    return {}
  },

  computed: {

    cameraOptions () {
      return getOptionsString({
        active: this.$store.getters.playerCameraIsActive,
        fov: this.$store.getters.playerCameraFov,
        zoom: this.$store.getters.playerCameraZoom
      })
    }

  }

}
</script>

<template>
  <a-entity
    geometry="width: 1; height: 1; depth: 2;"
    material="visible: false"
  >

    <a-entity
      ref="playerCamera"
      position="2 1 2"
      rotation="-25 45 0"
      :camera="cameraOptions"
    />

    <a-entity
      gltf-model="#soldiers"
      scale="0.05 0.05 0.05"
      position="0 -0.85 0"
    />

  </a-entity>
</template>
